module.exports = __webpack_public_path__ + "img/case4-华大.1effb85a.png";